import Base64Image from 'component/Base64Image'
import styled from 'styled-components'

export const Image = styled(Base64Image).attrs({ source: 'picture', aspectRatio: 840 / 400 })`
  width: 100%;
`
